export default "__VITE_ASSET__CYImNGwD__"